var map = {
	".": 59,
	"./": 59,
	"./App": 53,
	"./App.js": 53,
	"./App.test": 138,
	"./App.test.js": 138,
	"./CardsPile": 55,
	"./CardsPile.js": 55,
	"./EndRoundModal": 91,
	"./EndRoundModal.js": 91,
	"./InformationModal": 54,
	"./InformationModal.js": 54,
	"./MainGame": 90,
	"./MainGame.js": 90,
	"./Result": 92,
	"./Result.js": 92,
	"./constants/constants": 19,
	"./constants/constants.js": 19,
	"./images/background.jpeg": 492,
	"./images/cards/clubs_10.png": 493,
	"./images/cards/clubs_2.png": 494,
	"./images/cards/clubs_3.png": 495,
	"./images/cards/clubs_4.png": 496,
	"./images/cards/clubs_5.png": 497,
	"./images/cards/clubs_6.png": 498,
	"./images/cards/clubs_7.png": 499,
	"./images/cards/clubs_8.png": 500,
	"./images/cards/clubs_9.png": 501,
	"./images/cards/clubs_A.png": 502,
	"./images/cards/clubs_J.png": 503,
	"./images/cards/clubs_K.png": 504,
	"./images/cards/clubs_Q.png": 505,
	"./images/cards/diamonds_10.png": 506,
	"./images/cards/diamonds_2.png": 507,
	"./images/cards/diamonds_3.png": 508,
	"./images/cards/diamonds_4.png": 509,
	"./images/cards/diamonds_5.png": 510,
	"./images/cards/diamonds_6.png": 511,
	"./images/cards/diamonds_7.png": 512,
	"./images/cards/diamonds_8.png": 513,
	"./images/cards/diamonds_9.png": 514,
	"./images/cards/diamonds_A.png": 515,
	"./images/cards/diamonds_J.png": 516,
	"./images/cards/diamonds_K.png": 517,
	"./images/cards/diamonds_Q.png": 518,
	"./images/cards/hearts_10.png": 519,
	"./images/cards/hearts_2.png": 520,
	"./images/cards/hearts_3.png": 521,
	"./images/cards/hearts_4.png": 522,
	"./images/cards/hearts_5.png": 523,
	"./images/cards/hearts_6.png": 524,
	"./images/cards/hearts_7.png": 525,
	"./images/cards/hearts_8.png": 526,
	"./images/cards/hearts_9.png": 527,
	"./images/cards/hearts_A.png": 528,
	"./images/cards/hearts_J.png": 529,
	"./images/cards/hearts_K.png": 530,
	"./images/cards/hearts_Q.png": 531,
	"./images/cards/spades_10.png": 532,
	"./images/cards/spades_2.png": 533,
	"./images/cards/spades_3.png": 534,
	"./images/cards/spades_4.png": 535,
	"./images/cards/spades_5.png": 536,
	"./images/cards/spades_6.png": 537,
	"./images/cards/spades_7.png": 538,
	"./images/cards/spades_8.png": 539,
	"./images/cards/spades_9.png": 540,
	"./images/cards/spades_A.png": 541,
	"./images/cards/spades_J.png": 542,
	"./images/cards/spades_K.png": 543,
	"./images/cards/spades_Q.png": 544,
	"./images/examples/Game-example.gif": 545,
	"./images/examples/Start game.png": 546,
	"./index": 59,
	"./index.js": 59,
	"./service/GameService": 93,
	"./service/GameService.js": 93,
	"./serviceWorker": 94,
	"./serviceWorker.js": 94,
	"./setupTests": 177,
	"./setupTests.js": 177,
	"./styles/game.scss": 137,
	"./styles/variables.scss": 686
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;